import PropTypes from 'prop-types';
import { Icon } from '../common/Icons';
import { StyledContainer, StyledTitle } from './ScrollInfo.styles';

function ScrollInfo({ data }) {
  return (
    <StyledContainer>
      <Icon.Scroll aria-hidden />
      {data.title && <StyledTitle>{data.title}</StyledTitle>}
    </StyledContainer>
  );
}

ScrollInfo.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
  }),
};

ScrollInfo.defaultProps = {
  data: {
    title: 'Insert title',
  },
};

export default ScrollInfo;
